import React from "react";

import { Loader, Typography } from "@braintrust/braintrust-ui-components";
import { MODULE_EDIT_MODAL_PROPERTIES } from "@js/apps/freelancer/constants";
import { AccountInfoForm } from "@js/apps/freelancer/forms/account-info";
import { useAccountInfo } from "@js/apps/freelancer/hooks";
import { ModalInstance } from "@js/components/modal";
import type { Freelancer } from "@js/types/freelancer";

import styles from "./styles.module.scss";

export const openGeneralInfoModal = (profile: Freelancer) =>
  ModalInstance.open({
    children: <GeneralInfoModalContent profile={profile} />,
    ...MODULE_EDIT_MODAL_PROPERTIES,
    className: styles.modal,
  });

const GeneralInfoModalContent = ({ profile }: { profile: Freelancer }) => {
  const { isLoading, ...formConfig } = useAccountInfo(profile);

  if (isLoading) {
    return <Loader centered />;
  }

  return (
    <AccountInfoForm
      headerComponent={
        <Typography component="h3" variant="title" size="small" sx={{ mb: 4 }}>
          👋 Bio
        </Typography>
      }
      {...formConfig}
      onSubmitSuccess={() => {
        void formConfig.onSubmitSuccess();
        ModalInstance.close();
      }}
    />
  );
};
